import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { BrowserLocalstorage, authState } from '@/app/store'
import { Button, CustomField, Loader } from '@/shared'

import style from './Auth.module.scss'
import { useFields } from './useFields'

export const Auth = observer(() => {
    const navigate = useNavigate()

    const accessToken: string | null = BrowserLocalstorage.getToken()

    useEffect(() => {
        if (accessToken) navigate('/')
    }, [accessToken, navigate])

    const {
        login,
        loginError,
        onChangeLogin,
        onTouchLogin,
        onZeroLogin,
        password,
        passwordError,
        onChangePassword,
        onTouchPassword,
        onZeroPassword,
        isValidFields
    } = useFields()

    const onGetTokenByCreds = () => authState.onGetTokenByCreds({ login: login.value, password: password.value })
    return (
        <div className={style.container}>
            <div className={style.wrapper}>
                <div className={style.iconWrapper}>
                    <img
                        src={`${process.env.REACT_APP_API_URL}api/storage/logo.png`}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null
                            currentTarget.src =
                                'https://avatars.mds.yandex.net/i?id=d0c6a5c781cf8262ba1c22c4876c1429c58b4018-12509449-images-thumbs&n=13'
                        }}
                        alt='unknown'
                    />
                </div>
                {!authState.isFetching && (
                    <form>
                        <div className={style.fields}>
                            <CustomField
                                value={login.value}
                                placeholder={login.placeholder}
                                name={login.name}
                                onChange={onChangeLogin}
                                onFocus={onTouchLogin}
                                onZeroText={onZeroLogin}
                                error={loginError}
                            />
                            <CustomField
                                value={password.value}
                                placeholder={password.placeholder}
                                name={password.name}
                                onChange={onChangePassword}
                                onFocus={onTouchPassword}
                                onZeroText={onZeroPassword}
                                type='password'
                                error={passwordError}
                            />
                        </div>
                        <div className={style.btn}>
                            <Button type='submit' onClick={onGetTokenByCreds} disabled={isValidFields}>
                                Войти
                            </Button>
                        </div>
                    </form>
                )}
                {authState.isFetching && <Loader />}
            </div>
        </div>
    )
})
